export default __webpack_public_path__ + "static/media/background.a69c824f.png";